import api from './client';

export interface Inverter {
  ftp_connection_status?:number;
  modbus_connection_status?:number;
  energy_day_kwh?:number|null;
  energy_week_kwh?:number|null;
  energy_month_kwh?:number|null;
  energy_year_kwh?:number|null;
  energy_total_kwh?:number|null;
  power_kw?:number|null;
  internal_temperature?:number|null;
  performance_ratio?:number|null;
  has_panel_configuration?:boolean;
  tags?:Array<{id:number;label:string;color:string}>;
  id: number;
  inverter_name: string;
  brand: string;
  model: string;
  investor_name: string;
  investor_uuid?: string | null;
  plant_name: string;
  plant_uuid: string;
  e_day: string;
  e_total: string;
  plant_timezone?: string;
  last_seen: string | null;
  status: number;
}

export type InverterHeatmapRow = {
  inverter_id: number;
  inverter_uuid_id: string;
  inverter_name: string;
  inverter_capacity_kwp: number | null;
  plant_id: number;
  plant_uuid: string;
  plant_name: string;
  status: number;
  power_kw: number | null;
  daily_energy_kwh: number | null;
  performance_ratio: number | null;
  internal_temperature: number | null;
  plant_timezone?: string;
  last_seen: string | null;
};

export type InverterHeatmapResponse = {
  ok: boolean;
  plantUuid: string | null;
  rows: InverterHeatmapRow[];
  fetchedAt: string;
};

export interface SolarPanelSummary {
  solar_module_brand: string | null;
  solar_module_model: string | null;
  solar_module_max_module_power: number | null;
  solar_module_efficiency: number | null;
  solar_module_temperature_coefficient: number | null;
  module_quantity: number | null;
}

export async function fetchInverters(plantUuid?: string): Promise<Inverter[]> {
  const params = plantUuid ? { plant_uuid: plantUuid } : {};
  const res = await api.get<Inverter[]>('/inverters', { params });
  return res.data;
}

export async function fetchInverterSolarPanelSummary(id: number, stringNumber?: number): Promise<SolarPanelSummary[]> {
  const res = await api.get<SolarPanelSummary[]>(`/inverters/${id}/solar-panels`, {
    params: stringNumber === undefined ? undefined : { string_number: stringNumber },
  });
  return res.data ?? [];
}

export async function fetchInverterHeatmap(plantUuid?: string, tagIds: number[] = []): Promise<InverterHeatmapResponse> {
  const params: Record<string, string> = {};
  if (plantUuid) params.plant_uuid = plantUuid;
  if (tagIds.length > 0) params.tag_ids = tagIds.join(',');
  const res = await api.get<InverterHeatmapResponse>('/inverters/heatmap', { params });
  return res.data;
}
